import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pillarMetas } from '@/mocks/pillars';

export default function PillarsSection() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || 'en').split('-')[0];

  return (
    <section id="pillars" className="bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold tracking-widest text-primary-600">{t('pillars_eyebrow')}</span>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
            {t('pillars_title')}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{t('pillars_subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {pillarMetas.map((m) => (
            <Link
              key={m.slug}
              to={`/article/${m.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-white transition-all hover:border-primary-300 cursor-pointer"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={m.image}
                  alt={m.cardTitle[lang] || m.cardTitle.en}
                  title={`${m.cardTitle[lang] || m.cardTitle.en} USFans Spreadsheet`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {m.cardTitle[lang] || m.cardTitle.en}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {m.cardDesc[lang] || m.cardDesc.en}
                </p>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
                  {t('read_more')}
                  <span className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1">
                    <i className="ri-arrow-right-line" />
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}